module.exports = __webpack_public_path__ + "static/media/Vector-17.d4fcfabe.svg";